const BaseService = require('@/services/BaseService')

const namespace = 'reports/deactivations'

const findTemporaryDeactivation = (report, customer, cb, errorCb) => {
  BaseService.get(namespace + '/temporary-deactivation/' + report + '/' + customer, {}, cb, errorCb)
}

const findAll = (options, cb, errorCb) => {
  BaseService.get(namespace + '/deactivation', options, cb, errorCb)
}

const deactivate = (id, cb, errorCb) => {
  BaseService.post(namespace + '/deactivation/' + id, {}, cb, errorCb)
}

const reactivate = (id, cb, errorCb) => {
  BaseService.remove(namespace + '/deactivation/' + id, {}, cb, errorCb)
}

const temporaryDeactivate = (report, customer, cb, errorCb) => {
  BaseService.post(namespace + '/temporary-deactivation/' + report + '/' + customer, {}, cb, errorCb)
}

const temporaryReactivate = (id, cb, errorCb) => {
  BaseService.remove(namespace + '/temporary-deactivation/' + id, {}, cb, errorCb)
}

const findAllReportDeactivations = (id, options, cb, errorCb) => {
  BaseService.remove('reports/' + id + '/deactivations', options, cb, errorCb)
}

export {
  findAll,
  findTemporaryDeactivation,
  deactivate,
  reactivate,
  temporaryDeactivate,
  temporaryReactivate,
  findAllReportDeactivations
}
